import { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import config from "src/config/config";
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function SurpriseDhamakaEvoFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const evoGameUrls = {
        SDEvoGames01: "/live-casino/evolution/lightning-roulette",
        SDEvoGames02: "/live-casino/evolution/dragon-tiger",
        SDEvoGames03: "/live-casino/evolution/crazy-time",
        SDEvoGames04: "/live-casino/evolution/super-andar-bahar",
        SDEvoGames05: "/live-casino/evolution/xxxlightningroulette",
        SDEvoGames06: "/live-casino/evolution/super-sicbo",
        SDEvoGames07: "/live-casino/evolution/xxxlightningbaccarat",
        SDEvoGames08: "/instant-games/evolution/stock-market",
        SDEvoGames09: "/live-casino/evolution/teenpatti",
        SDEvoGames10: "/live-casino/evolution/ice-fishing",
    };

    return (
        <>
            <InformationWrapper>
                <TitleText className='fun88theme'>
                    <h2>Win Daily Surprises up to <span>₹50,000!</span></h2>
                    <p>
                        Light up your gaming days with big wins! Bet on selected Evolution games daily and grab surprise bonuses—every bet could <br /> make you a festive winner!
                    </p>   
                </TitleText>

                <HTPMainSec className='fun88theme'>
                    <MainTitle>How to participate</MainTitle>
                    <p><strong>1. </strong>Play any of the <strong>selected games :</strong> </p>
                    <HTPGamesSec>
                        {Object.keys(evoGameUrls).map((gameKey, index) => (
                            <Link key={index} to={evoGameUrls[gameKey]}>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image[gameKey]}`}
                                alt={gameKey}
                            />
                            </Link>
                        ))}
                    </HTPGamesSec>
                    <p><strong>2. </strong>Bet <strong>₹10,000 or more </strong>in a single day</p>
                    <p><strong>3. </strong>Receive a surprise bonus instantly <strong>(₹100 - ₹50,000).</strong></p>
                </HTPMainSec>

                <TermsAndCondition className='fun88theme'>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>Valid on <strong>selected Evolution games</strong></li>
                        <li><strong>One bonus per player per day</strong></li>
                        <li>Bonuses credited <strong>instantly</strong></li>
                        <li>First <strong>10,000 players</strong> qualify for the promotion</li>
                        <li>Promotion runs <strong>throughout November 2025</strong></li>
                        <li>Standard <strong>brand T&Cs</strong> apply</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(SurpriseDhamakaEvoFun));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 3rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: #EBEBEB;
    overflow: hidden;


    .fun88theme {
        background: #fff;
        border-radius: 10px;
        width: 70%;
        margin: 1em auto;
    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem;
    position: relative;
    gap: 15px;
 

    p {
        color: #444;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }

    h2 {
        color: #06A6FF;
        text-align: center;
        font-size: 19.556px;
        font-style: normal;
        font-weight: 700;
        line-height: 29.578px; /* 151.25% */
        text-transform: capitalize;
        margin: 2px 0px;

        & span {
            color: #06A6FF;
            font-size: 19.556px;
            font-style: normal;
            font-weight: 700;
            line-height: 29.578px;
            text-transform: capitalize;
        }
    }
`;


const MainTitle = styled.h2`
    width: 100%;
    color: #06A6FF;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    margin: 0;
    padding: 1rem 1rem 1rem 1rem;
`;


const TermsAndCondition = styled.div`
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem auto;
    padding: 1rem;
    
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        list-style-type: disc;
        justify-content: center;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;

        li {
            color: #444;
            text-align: justify;
            font-size: 15px;
            font-style: normal;
            font-weight: 300;
            line-height: 28px;
            text-transform: capitalize;

            strong {
                font-weight: 900;
            }
        }
    }
`;

const HTPMainSec = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem auto;
    width: 70%;
    height: auto;
    gap: 10px;
    padding-bottom: 1em;

    & p {
        color: #444;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21.6px;
        text-transform: capitalize;
        margin: 2px 0px;

        & strong {
            color: #444;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 900;
            line-height: 21.6px; /* 154.286% */
            text-transform: capitalize;
            margin: 2px 0px;
        }
    }
`

const HTPGamesSec = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    gap: 10px;
    margin: 2em 0em;
    justify-content: center;

    & img {
        width: 150px;
        height: auto;
        object-fit: contain;
    }
`